import { render, staticRenderFns } from "./ProjectLayout.vue?vue&type=template&id=2f80917e"
import script from "./ProjectLayout.vue?vue&type=script&lang=js"
export * from "./ProjectLayout.vue?vue&type=script&lang=js"
import style0 from "./ProjectLayout.vue?vue&type=style&index=0&id=2f80917e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports